import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  RenderingProps,
  KeyValuePair,
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
} from 'src/shared/shared.types';

export type B03HeroFeaturedBannerProps = RenderingProps<
  B03HeroFeaturedBannerFields,
  B03HeroFeaturedBannerRenderingParams
>;

export type B03HeroFeaturedBannerFields = {
  TaglineTop?: Field<string>;
  Headline?: Field<string>;
  TaglineBottom?: Field<string>;
  BackgroundImage?: ImageField;
  FirstCTA?: LinkField;
  FirstCTAIcon?: KeyValuePair;
  SecondCTA?: LinkField;
  SecondCTAIcon?: KeyValuePair;
  MobileBackgroundImage?: ImageField;
};

export type B03HeroFeaturedBannerRenderingParams = {
  Gradient?: string;
  FirstCTAStyle?: string;
  SecondCTAStyle?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;
